import { Controller } from "@hotwired/stimulus"
import { Turbo } from "@hotwired/turbo-rails"

export default class extends Controller {
  static values = {
    frame: String,
    path: String
  }

  visit(event) {
    const field = event.target;
    const paramName = field.name.match(/\[(\w+)\]$/)[1]; // Extracts 'plan_id' from 'subscription[plan_id]'

    // Start with current URL and all existing query params
    const currentUrl = new URL(window.location.href);
    const url = new URL(window.location.origin + this.pathValue);

    // Preserve all current params except the one being changed
    currentUrl.searchParams.forEach((value, key) => {
      if (key !== paramName) {
        url.searchParams.set(key, value);
      }
    });

    // Set the new param value
    // For date fields, ensure we use the value as-is (it's already a date string from the select)
    const paramValue = field.value;
    url.searchParams.set(paramName, paramValue);

    const location = `${url.pathname}${url.search}`
    if (this.hasFrameValue && this.frameValue) {
      Turbo.visit(location, {frame: this.frameValue})
    } else {
      Turbo.visit(location, {action: "replace"})
    }
  }
}
